import { store } from '@/redux/store'

import { W3ResponseType } from '../events'
import { w3Api } from '../w3Api'
import { RequestBecomeKOL } from './kols.type'

export const endpoints = {
  becomeKOL: '/kol-submission',
}

const KOLsApi = w3Api.injectEndpoints({
  endpoints: (build) => ({
    becomeKOL: build.mutation<W3ResponseType, RequestBecomeKOL>({
      query: (args) => {
        return {
          url: endpoints.becomeKOL,
          method: 'POST',
          body: args,
        }
      },
      invalidatesTags() {
        const state = store.getState()
        const creator = state.root.auth.user?.id
        return [{ type: 'Profile', id: creator }]
      },
    }),
  }),
  overrideExisting: false,
})

export const { useBecomeKOLMutation } = KOLsApi
